<template lang="pug">
  v-container#perpetrators(fluid)
    h1.form-title2.accent-text.pb-5 Información sobre perpetradores
    v-row.py-1(justify="space-between")
       v-col(d-flex xs=12 sm=6)
          v-row
            label.custom.mb-2 ¿Identifica a los victimarios? 
          v-row
            v-col.align-radios(d-flex xs=4 sm=3)
              v-radio-group(v-model="perpetratorsIdentified" row hide-details @change="clearOptions(directAnswers[$event].slug,'perpetratorType')")
                v-radio(
                	v-for="(perpetratorsIdentifiedOpt, i) in directAnswers"
                	:key="`perpetratorsIdentifiedOpt${i}`"
                	:value="i"
                	:label="perpetratorsIdentifiedOpt.name"
                )
       v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Pudo ver cuántos vehículos eran?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeVehiclesQty" row hide-details @change="clearDetails($event,'vehicle')")
              v-radio(
              	v-for="(noticeVehiclesQtyOpt, i) in directAnswers"
              	:key="`noticeVehiclesQtyOpt${i}`"
              	:value="i"
              	:label="noticeVehiclesQtyOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="vehicle"
              :disabled = "!!noticeVehiclesQty"
            	v-model="vehiclesQuantityInfo"
            	hide-details
            )
       
    v-row.py-1(justify="space-between")
      v-col(d-flex xs=12 sm=6)
          v-row.py-1.checkboxes(align="end"  v-if="perpetratorsIdentified == 0")
            v-col(d-flex xs=12 sm=12)
              v-row
                label.custom.mb-2 Tipo de victimario
            v-checkbox(
              v-model="perpetratorType"
              label="Agentes del Estado"
              value="Agentes del Estado"
              color="main-color"
              hide-details
            )
            v-checkbox(
              v-model="perpetratorType"
              label="Grupo delictivo"
              value="Grupo delictivo"
              color="main-color"
              hide-details
            )
            v-checkbox(
              v-model="perpetratorType"
              label="Otro"
              value="Otro"
              color="main-color"
              hide-details
            )

          v-row.py-1(v-if="showOtherPerpetrator == true && perpetratorsIdentified == 0")
            v-col.pr-2(d-flex xs=12 sm="10")
              v-text-field(
              	v-model="otherPerpetrator"
              	label="Especificar"
              )
              
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Tenían un acento especial?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeAccent" row hide-details @change="clearDetails($event,'accent')")
              v-radio(
              	v-for="(accentOpt, i) in directAnswers"
              	:key="`accentOpt${i}`"
              	:value="i"
              	:label="accentOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref= "accent"
              :disabled = "!!noticeAccent"
            	v-model="accentDescription"
            	hide-details
            )
    v-row.py-1(justify="space-between")
      v-col.pr-2(d-flex xs=12 sm=5)
        v-text-field(
        	v-model="perpetratorsQuantity"
          label="¿Cuántos eran?"
        )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Usaban claves alfanuméricas?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeCodeSpeaking" row hide-details @change="clearDetails($event,'code')")
              v-radio(
              	v-for="(noticeCodeOpt, i) in directAnswers"
              	:key="`noticeCodeOpt${i}`"
              	:value="i"
              	:label="noticeCodeOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="code"
              :disabled = "!!noticeCodeSpeaking"
            	v-model="codeDescription"
            	hide-details
            )



    v-row.py-1(justify="space-between")
      v-col.pr-2(d-flex xs=12 sm=5)
        v-text-field(
        	v-model="clothesDescription"
        	label="¿Cómo vestían? (uniformes, pasamontañas, llevaban esposas, botas de policía, etc)"
        )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Portaban armas?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeWeapons" row hide-details @change="clearDetails($event,'weapons')")
              v-radio(
              	v-for="(noticeWeaponsOpt, i) in directAnswers"
              	:key="`noticeWeaponsOpt${i}`"
              	:value="i"
              	:label="noticeWeaponsOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="weapons"
              :disabled = "!!noticeWeapons"
            	v-model="weaponsDescription"
            	hide-details
            )
     

    v-row.pt-1.pb-5(justify="space-between")
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Pudo identificar alguna frase o amenaza que dijeron?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeThreat" row hide-details @change="clearDetails($event,'threat')")
              v-radio(
              	v-for="(noticeThreatOpt, i) in directAnswers"
              	:key="`noticeThreatOpt${i}`"
              	:value="i"
              	:label="noticeThreatOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="threat"
              :disabled = "!!noticeThreat"
            	v-model="threatDescription"
            	hide-details
            )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Alguna otra seña particular?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeParticularSign" row hide-details @change="clearDetails($event,'particular-sign')")
              v-radio(
              	v-for="(noticeSignOpt, i) in directAnswers"
              	:key="`noticeSignOpt${i}`"
              	:value="i"
              	:label="noticeSignOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="particular-sign"
              :disabled = "!!noticeParticularSign"
            	v-model="signDescription"
            	hide-details
            )
      

    v-row.pt-1.pb-5(justify="space-between")
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 Los vehículos o las personas, ¿los identifican previamente en la zona o en otro lugar?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeVehiclesBefore" row hide-details @change="clearDetails($event,'notice-before')")
              v-radio(
              	v-for="(noticeVehiclesBeforeOpt, i) in directAnswers"
              	:key="`noticeVehiclesBeforeOpt${i}`"
              	:value="i"
              	:label="noticeVehiclesBeforeOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="notice-before"
              :disabled = "!!noticeVehiclesBefore"
            	v-model="vehiclesDescription"
            	hide-details
            )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-text-field(
        	v-model="observers"
          label="¿Quiénes observaron o pudieron observar la detención?"
        )
      

    v-row.pt-1.pb-5(justify="space-between")
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Pudo ver con qué rumbo partieron?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="noticeEscapeRoute" row hide-details @change="clearDetails($event,'escape-route')")
              v-radio(
              	v-for="(noticeRouteOpt, i) in directAnswers"
              	:key="`noticeRouteOpt${i}`"
              	:value="i"
              	:label="noticeRouteOpt.name"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="escape-route"
              :disabled = "!!noticeEscapeRoute"
            	v-model="routeDescription"
            	hide-details
            )
      

</template>

<script>
export default {
  name: "Perpetrators",
  computed: {
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    showOtherPerpetrator() {
      if (!this.perpetratorType.includes("Otro")) this.otherPerpetrator = "";
      return this.perpetratorType.includes("Otro");
    },
    perpetratorsIdentified: {
      get() {
	    	return this.directAnswers.findIndex(directAnswer =>
          directAnswer.slug == this.$store.state.record.narrative.perpetrators.perpetratorsIdentified.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.perpetratorsIdentified = this.directAnswers[index];
      }
    },
    perpetratorType: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.perpetratorType;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.perpetratorType = value;
    	}
    },
    otherPerpetrator: {
      get() {
        return this.$store.state.record.narrative.perpetrators.otherPerpetrator;
      },
      set(value) {
        this.$store.state.record.narrative.perpetrators.otherPerpetrator = value;
      }
    },
    perpetratorsQuantity: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.quantity;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.quantity = value;
    	}
    },
    noticeAccent: {
	    get() {
	    	return this.directAnswers.findIndex(
          accentOpt => accentOpt.slug == this.$store.state.record.narrative.perpetrators.noticeAccent.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeAccent = this.directAnswers[index];
      }
    },
    accentDescription: {
	    get() { 
    		return this.$store.state.record.narrative.perpetrators.accentDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.accentDescription = value;
    	}
    },
    clothesDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.clothesDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.clothesDescription = value;
    	}
    },
    noticeCodeSpeaking: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeCodeOpt => noticeCodeOpt.slug == this.$store.state.record.narrative.perpetrators.noticeCodeSpeaking.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeCodeSpeaking = this.directAnswers[index];
      }
    },
    codeDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.codeDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.codeDescription = value;
    	}
    },
    noticeThreat: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeThreatOpt => noticeThreatOpt.slug == this.$store.state.record.narrative.perpetrators.noticeThreat.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeThreat = this.directAnswers[index];
      }
    },
    threatDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.threatDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.threatDescription = value;
    	}
    },
    noticeWeapons: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeWeaponsOpt => noticeWeaponsOpt.slug == this.$store.state.record.narrative.perpetrators.noticeWeapons.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeWeapons = this.directAnswers[index];
      }
    },
    weaponsDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.weaponsDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.weaponsDescription = value;
    	}
    },
    noticeVehiclesBefore: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeVehiclesBeforeOpt => noticeVehiclesBeforeOpt.slug == this.$store.state.record.narrative.perpetrators.noticeVehiclesBefore.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeVehiclesBefore = this.directAnswers[index];
      }
    },
    vehiclesDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.vehiclesDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.vehiclesDescription = value;
    	}
    },
    noticeParticularSign: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeSignOpt => noticeSignOpt.slug == this.$store.state.record.narrative.perpetrators.noticeParticularSign.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeParticularSign = this.directAnswers[index];
      }
    },
    signDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.signDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.signDescription = value;
    	}
    },
    noticeEscapeRoute: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeRouteOpt => noticeRouteOpt.slug == this.$store.state.record.narrative.perpetrators.noticeEscapeRoute.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeEscapeRoute = this.directAnswers[index];
      }
    },
    routeDescription: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.routeDescription;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.routeDescription = value;
    	}
    },
    observers: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.observers;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.observers = value;
    	}
    },
    noticeVehiclesQty: {
	    get() { 
	    	return this.directAnswers.findIndex(
          noticeVehiclesQtyOpt => noticeVehiclesQtyOpt.slug == this.$store.state.record.narrative.perpetrators.noticeVehiclesQty.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.perpetrators.noticeVehiclesQty = this.directAnswers[index];
      }
    },
    vehiclesQuantityInfo: {
    	get() { 
    		return this.$store.state.record.narrative.perpetrators.vehiclesQuantityInfo;
    	},
    	set(value) {
    		this.$store.state.record.narrative.perpetrators.vehiclesQuantityInfo = value;
    	}
    }
  },
  methods: {
    clearDetails(value, reference) {
      if(!!value) {
        this.$refs[reference].internalValue = "";
      }
    },
    clearOptions(value, reference) {
      if(value == "no") {
        this[reference] = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.align-radios {
  align-self: flex-end;
}

.checkboxes {
  justify-content: space-evenly;
}
</style>
